import React from 'react';

const ScoobyKatale = () => {
  return (
    <iframe
      src="/sisu-theme/sisu-katale-index.html"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block'
      }}
      title="Scoobydoo International School Uganda (SISU) - Katale Campus"
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-downloads"
    />
  );
};

export default ScoobyKatale;
